/**
 * Единый источник дизайн-токенов СпортПрогресс (sport.mos.ru).
 * Импортируйте отсюда — не хардкодьте цвета в компонентах.
 */

export const Colors = {
  primary: '#EB3333',
  primaryDark: '#C41E1E',
  primaryLight: '#FF5555',
  primaryBg: '#FFF5F5',

  white: '#FFFFFF',
  black: '#1A1A1A',
  gray50: '#F8F8F8',
  gray100: '#F0F0F0',
  gray200: '#E0E0E0',
  gray300: '#BDBDBD',
  gray400: '#9E9E9E',
  gray600: '#616161',
  gray900: '#1A1A1A',

  success: '#2E7D32',
  successLight: '#E8F5E9',
  warning: '#F57C00',
  warningLight: '#FFF3E0',
  error: '#C62828',
  errorLight: '#FFEBEE',
  info: '#1565C0',
  infoLight: '#E3F2FD',

  overlay: 'rgba(0,0,0,0.5)',
  overlayLight: 'rgba(0,0,0,0.3)',
};

export const Typography = {
  fontFamily: "'PT Sans', 'PT Sans Narrow', Arial, sans-serif",
  fontFamilyHeading: "'PT Sans Narrow', 'PT Sans', Arial, sans-serif",
  fontFamilyMono: 'monospace',

  xs: '11px',
  sm: '13px',
  base: '15px',
  md: '17px',
  lg: '20px',
  xl: '24px',
  xxl: '32px',
  xxxl: '40px',
  hero: '56px',

  regular: 400,
  medium: 500,
  bold: 700,
  black: 900,

  tight: 1.2,
  normal: 1.5,
  loose: 1.8,
};

export const Spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
  xxxl: '64px',
  section: '80px',
};

export const Radius = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  full: '100px',
};

export const Shadows = {
  card: '0 4px 16px rgba(0,0,0,0.10)',
  hover: '0 8px 24px rgba(235,51,51,0.18)',
  header: '0 2px 12px rgba(0,0,0,0.15)',
  modal: '0 16px 48px rgba(0,0,0,0.20)',
};

export const Breakpoints = {
  mobile: '767px',
  tablet: '1023px',
  desktop: '1280px',
};

export const MobileColors = { ...Colors };

export const MobileTypography = {
  xs: 11,
  sm: 13,
  base: 15,
  md: 17,
  lg: 20,
  xl: 24,
  xxl: 28,
  xxxl: 32,
};

export const MobileSpacing = {
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  xxl: 48,
};

export const MobileRadius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20,
  full: 100,
};

/** CSS custom properties для глобальных стилей */
export function applyCssVariables() {
  if (typeof document === 'undefined') return;
  const r = document.documentElement;
  Object.entries(Colors).forEach(([k, v]) => r.style.setProperty(`--sp-${k.replace(/[A-Z]/g, m => `-${m.toLowerCase()}`)}`, v));
  r.style.setProperty('--sp-font', Typography.fontFamily);
  r.style.setProperty('--sp-font-heading', Typography.fontFamilyHeading);
}
